/**
 * Time unit multiplier for the relative initial fixing date offset.
 * tag: 40760
 * @readonly
 * @enum {string} (String)
 */
export enum PaymentStreamPaymentDateOffsetUnit {
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
